import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "@/lib/utils"

const headingVariants = cva("", {
  variants: {
    level: {
      h1: "h1-core",
      h2: "h2-core",
      h3: "h3-core",
    },
  },
  defaultVariants: {
    level: "h1",
  },
})

export type HeadingProps = React.HTMLAttributes<HTMLHeadingElement> &
  VariantProps<typeof headingVariants>

const Heading = ({ className, level = "h1", ...props }: HeadingProps) => {
  const Component = level || "h1"
  return <Component className={cn(headingVariants({ level }), className)} {...props} />
}
Heading.displayName = "Heading"

export { Heading, headingVariants }
